import { DateTime } from 'luxon';
import type { SigningPageRecipient } from '../types/signing-page-recipient';
import type { Recipient } from '../types/Recipient';
import { EnumDocumentType } from '../enums/DocumentType';
import { RecipientStatus } from '../recipients/enums/recipient-status';

export function isExpired(date: string): boolean {
  const expirationDate: DateTime = DateTime.fromISO(date);
  const currentDate: DateTime = DateTime.now();
  return currentDate > expirationDate;
}

export function isPartiallySignedOrApproved(
  recipients: Recipient[] | SigningPageRecipient[]
): boolean {
  if (!recipients.length) {
    return false;
  }
  return recipients.some(({ status }) =>
    [RecipientStatus.Signed, RecipientStatus.Approved].includes(status)
  );
}

export function isNonSignableDocument(documentType: EnumDocumentType): boolean {
  return [EnumDocumentType.Introduction, EnumDocumentType.Presentation].includes(documentType);
}
